import React, { useState } from "react";
import AmenitesList from "./amenitesList";
import WalkScore from "./walkscore";
import { Link } from "react-router-dom";
import moment from "moment";
import NeighborhoodPage from "./neighborhoodPage";
import AmenitesListPopUp from "./amenitiesLIstPopUp";
import GreatSchoolsPage from "./greatSchoolsPage";
import GreatSchoolsPopUp from "./greatSchoolsPopUp";
import { Tooltip } from "antd";
import OwlCarousel from "react-owl-carousel";
import FullPopup from "../newinterface/fullPopup";

const Communitys = (props) => {
  const { communitysList, displayView } = props;
  const [selectedOption, setSelectedOption] = useState(0);
  const [amenitiesModalOpen, setAmenitiesModalOpen] = useState(false);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [selected, setSelected] = useState(null);
  const [communityData, setCommunityData] = useState("");

  let showMoreInfoTab;

  const booked = _.filter(communitysList, function (o) {
    return o.LinkMaster.IsGuestBooked == true;
  });
  const notespresent = _.filter(communitysList, function (o) {
    return o.LinkMaster.Notes != null;
  });

  function AmenitiesRes(community, index, showMoreInfoTab) {
    const appartmentAmenities =
      community.AmenitiesList != null && community.AmenitiesList != undefined
        ? JSON.parse(community.AmenitiesList)
        : community.AmenitiesList;
    const apparmentamenites =
      appartmentAmenities != null && appartmentAmenities != undefined
        ? _.filter(appartmentAmenities, function (o) {
            return o.communityname == "Unit";
          })
        : [];
    const communityamenites =
      appartmentAmenities != null && appartmentAmenities != undefined
        ? _.filter(appartmentAmenities, function (o) {
            return o.communityname == "Community";
          })
        : [];
    return (
      <AmenitesList
        indexval={index}
        appartmentAmenities={apparmentamenites}
        communityAmenities={communityamenites}
        LinkMaster={community.LinkMaster}
        showMoreInfoTab={showMoreInfoTab}
      />
    );
  }

  const handleAmenitesPopUp = (community) => {
    setSelectedCommunity(community);
    setAmenitiesModalOpen(true);
  };
  const handleSchoolsPopUp = (community) => {
    setSelected(community);
  };
  const handleNeigbborHoodPopUp = (community) => {
    setSelected(community);
  };
  const shouldShowOfferRate = communitysList.some(
    (community) =>
      community.LinkMaster.DontShowPrice == null ||
      community.LinkMaster.DontShowPrice === false
  );
  const anyCommunityBooked = communitysList.some(
    (c) => c.LinkMaster.IsGuestBooked
  );

  const handleCloseModal = () => {
    setAmenitiesModalOpen(false);
    setSelectedCommunity(null); // optional: reset state
  };

  const handleOpenCarousel = async (row) => {
    // console.log("Opening carousel with images:", images);
    const popUPimages =
      row?.CommunityImages != null && row?.CommunityImages != undefined
        ? JSON.parse(row?.CommunityImages)
        : [];

    row.CommunityImages = JSON.stringify(popUPimages);
    setCommunityData(row);
    setTimeout(() => {
      try {
        if (window.jQuery) {
          window.jQuery("#fullmodel-Carousel1").modal("show");
          window.jQuery("#fullmodel-Carousel1 .modal-body").scrollTop(0);
        } else {
          console.error("jQuery is not available");
        }
      } catch (error) {
        console.error("Error showing carousel modal:", error);
      }
    }, 100);

    // Use a short timeout to ensure state is updated before showing modal
  };
  return (
    <>
      {displayView == "grid" ? (
        <div>
          {/* UI options as tabs */}
          <ul className="optionView">
            {communitysList.map((_, idx) => (
              <li
                key={idx}
                className={selectedOption === idx ? "active" : ""}
                onClick={() => setSelectedOption(idx)}
              >
                Option-{idx + 1}
              </li>
            ))}
          </ul>

          {/* Conditionally render selected community */}
          {communitysList[selectedOption] && (
            <div
              className={`${
                anyCommunityBooked &&
                !communitysList[selectedOption].LinkMaster.IsGuestBooked
                  ? "notsuiteBooked"
                  : ""
              }`}
              key={selectedOption}
            >
              <div
                className={`top ${
                  communitysList[selectedOption].LinkMaster.Notes != null
                    ? " notepresent"
                    : ""
                }`}
              >
                <div className="details">
                  <h1>{communitysList[selectedOption].community_name}</h1>
                  <p className="mb-2">
                    {communitysList[selectedOption].address +
                      ", " +
                      communitysList[selectedOption].city_name +
                      ", " +
                      communitysList[selectedOption].state_name +
                      ", " +
                      communitysList[selectedOption].ZipCode}
                  </p>

                  <h2 className="mb-3">
                    Available from:{" "}
                    <span>
                      {communitysList[selectedOption].LinkMaster.MoveInReady !=
                      null
                        ? moment(
                            communitysList[selectedOption].LinkMaster
                              .MoveInReady
                          ).format("MMMM DD, YYYY")
                        : moment(
                            communitysList[selectedOption].LinkMaster.MoveInDate
                          ).format("MMMM DD, YYYY")}
                    </span>
                  </h2>
                  {communitysList[selectedOption].LinkMaster.OfferedRate !==
                    0 && (
                    <h3>
                      {communitysList[selectedOption].LinkMaster
                        .DontShowPrice == null ||
                      (communitysList[selectedOption].LinkMaster
                        .DontShowPrice == false &&
                        communitysList[selectedOption].LinkMaster
                          .OfferedRate !== 0) ? (
                        <b>
                          Offered Rate:{" "}
                          <span>
                            {" "}
                            $
                            {
                              communitysList[selectedOption].LinkMaster
                                .OfferedRate
                            }
                            /day{" "}
                          </span>
                        </b>
                      ) : null}
                    </h3>
                  )}

                  <ul className="CommunityMoreInfo">
                    {communitysList[selectedOption].LinkMaster.SuiteSizeCode !=
                    null ? (
                      <li>
                        {" "}
                        <img src="/assets/newUI-images/quotes/size.svg" />
                        <b>
                          {
                            communitysList[selectedOption].LinkMaster
                              .SuiteSizeCode
                          }
                        </b>
                      </li>
                    ) : null}

                    {communitysList[selectedOption].LinkMaster.Floor != null ? (
                      <li>
                        {" "}
                        <img src="/assets/newUI-images/quotes/appartments.svg" />{" "}
                        <b>
                          Floor{" "}
                          {communitysList[selectedOption].LinkMaster.Floor}{" "}
                        </b>
                      </li>
                    ) : null}
                    {communitysList[selectedOption].LinkMaster.SquareFootage !=
                    null ? (
                      <li>
                        {" "}
                        <img src="/assets/newUI-images/quotes/house-plan.svg" />{" "}
                        <b>
                          {
                            communitysList[selectedOption].LinkMaster
                              .SquareFootage
                          }{" "}
                          ft<sup>2</sup>
                        </b>
                      </li>
                    ) : null}

                    {(communitysList[selectedOption].LinkMaster.Parking ||
                      communitysList[selectedOption].LinkMaster.Parking2 ||
                      communitysList[selectedOption].LinkMaster
                        .NewOptionParking) &&
                      (() => {
                        let parkingCount = [
                          communitysList[selectedOption].LinkMaster.Parking,
                          communitysList[selectedOption].LinkMaster.Parking2,
                          // communitysList[selectedOption].LinkMaster
                          //   .NewOptionParking,
                        ].filter(
                          (p) => p !== null && p !== "" && p !== "none"
                        ).length;
                        parkingCount =
                          parkingCount +
                          parseInt(
                            +communitysList[selectedOption].LinkMaster
                              .NewOptionParking
                          );
                        return (
                          parkingCount > 0 && (
                            <li>
                              <img
                                className="parking"
                                src="/assets/newUI-images/quotes/parkingSpace.svg"
                              />
                              <b>
                                {parkingCount}{" "}
                                {parkingCount === 1 ? "Space" : "Spaces"}
                              </b>{" "}
                            </li>
                          )
                        );
                      })()}
                  </ul>

                  {(communitysList[selectedOption].LinkMaster.Frequency ||
                    communitysList[selectedOption].LinkMaster.NTV) && (
                    <ul className="CommunityMoreInfo more">
                      {communitysList[selectedOption].LinkMaster.Frequency !=
                        null &&
                        communitysList[selectedOption].LinkMaster.Frequency !==
                          "" && (
                          <li>
                            <b>
                              {
                                communitysList[selectedOption].LinkMaster
                                  .Frequency
                              }
                            </b>
                            Housekeeping
                          </li>
                        )}

                      {communitysList[selectedOption].LinkMaster.NTV && (
                        <li>
                          <b>{communitysList[selectedOption].LinkMaster.NTV}</b>{" "}
                          {communitysList[selectedOption].LinkMaster.NTV === 1
                            ? "Day"
                            : "Days"}{" "}
                          NTV{" "}
                          <Tooltip
                            title={`Please let us know at least ${
                              communitysList[selectedOption].LinkMaster.NTV
                            } ${
                              communitysList[selectedOption].LinkMaster.NTV ===
                              1
                                ? "day"
                                : "days"
                            } before your scheduled move-out date if you plan to move out or would like to extend your stay.`}
                          >
                            <i className="bi bi-info-circle-fill cursor-pointer"></i>
                          </Tooltip>
                        </li>
                      )}

                      {/* {(() => {
                        const linkMaster =
                          communitysList[selectedOption]?.LinkMaster || {};
                        const bedCounts = Object.keys(linkMaster)
                          .filter((key) => key.startsWith("BedRoom"))
                          .reduce((acc, key) => {
                            const bedType = linkMaster[key]?.trim();
                            if (bedType) {
                              acc[bedType] = (acc[bedType] || 0) + 1;
                            }
                            return acc;
                          }, {});

                        const bedCountString = Object.entries(bedCounts)
                          .map(([bedType, count]) => `${count} ${bedType}`)
                          .join(", ");
                        return (
                          Object.keys(bedCounts).length > 0 && (
                            <li>
                              {Object.entries(bedCounts).map(
                                ([bedType, count], idx, arr) => (
                                  <span key={bedType}>
                                    <b>{count}</b> {bedType}
                                    {idx < arr.length - 1 && ", "}
                                  </span>
                                )
                              )}
                            </li>
                          )
                        );
                      })()} */}
                    </ul>
                  )}
                  {communitysList[selectedOption].LinkMaster.Notes && (
                    <div className="newpara-ptag">
                      <div className="alert alert-info">
                        <i className="fa fa-info-circle"></i>{" "}
                        {communitysList[selectedOption].LinkMaster.Notes}
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className={
                    communitysList[selectedOption].LinkMaster.IsGuestBooked ===
                    true
                      ? "selectView  suiteBooked"
                      : "selectView"
                  }
                >
                  {communitysList[selectedOption].LinkMaster.IsGuestBooked ? (
                    <button className="btn btn-border-black">
                      <i className="bi bi-check-circle-fill"></i>
                      Booked
                    </button>
                  ) : booked.length === 0 ? (
                    <button
                      className="btn btn-border-black"
                      onClick={() =>
                        props.bookNow(communitysList[selectedOption])
                      }
                    >
                      Book Now
                    </button>
                  ) : null}
                </div>
              </div>

              <div className="communityImages ">
                {(() => {
                  const communityImages =
                    communitysList[selectedOption]?.CommunityImages != null &&
                    communitysList[selectedOption]?.CommunityImages != undefined
                      ? JSON.parse(
                          communitysList[selectedOption]?.CommunityImages
                        )
                      : [];

                  if (communityImages.length > 0) {
                    return (
                      <div className="image">
                        <img
                          src={communityImages[0].image_name}
                          alt={`${communityImages[0].image_name} banner`}
                        />
                        {communityImages.length > 1 && (
                          <button
                            className="btn photos"
                            onClick={() =>
                              handleOpenCarousel(communitysList[selectedOption])
                            }
                            type="button"
                          >
                            + {communityImages.length - 1} Photos
                          </button>
                        )}
                      </div>
                    );
                  }
                  return (
                    <div className="image">
                      <img
                        src={communitysList[selectedOption].banner_image}
                        alt=""
                      />
                    </div>
                  );
                })()}

                {AmenitiesRes(
                  communitysList[selectedOption],
                  selectedOption,
                  (showMoreInfoTab = false)
                )}
              </div>
            </div>
          )}
          {communitysList[selectedOption] && (
            <div className="sa-community-details">
              <NeighborhoodPage
                key={`neighborhood-${selectedOption}`}
                community={communitysList[selectedOption]}
              />
              <GreatSchoolsPage
                key={`schools-${selectedOption}`}
                community={communitysList[selectedOption]}
              />
            </div>
          )}
        </div>
      ) : displayView == "list" ? (
        <div className="communitiesOptionsListView table-responsive">
          <table className={`${notespresent.length > 0 ? "notepresent" : ""}`}>
            <thead>
              <tr>
                <th>Community Name</th>
                <th>Available From</th>
                {shouldShowOfferRate && <th>Offer Rate</th>}
                <th></th>
              </tr>
            </thead>

            <tbody>
              {communitysList.map((community, index) => {
                const anyCommunityBooked = communitysList.some(
                  (c) => c.LinkMaster.IsGuestBooked
                );
                const isBooked = community.LinkMaster.IsGuestBooked;
                const extraDetails = [
                  community.LinkMaster.NTV,
                  community.LinkMaster.Frequency,
                ].some((val) => val !== null && val !== "");
                const linkMaster = community.LinkMaster;

                // Count bed types dynamically from BedRoom1 to BedRoom10
                const bedCounts = Object.keys(linkMaster)
                  .filter((key) => key.startsWith("BedRoom"))
                  .reduce((acc, key) => {
                    const bedType = linkMaster[key]?.trim();
                    if (bedType) {
                      acc[bedType] = (acc[bedType] || 0) + 1;
                    }
                    return acc;
                  }, {});
                const bedCountString = Object.entries(bedCounts)
                  .map(([bedType, count]) => `${count} ${bedType}`)
                  .join(", ");
                let communityImages =
                  community.CommunityImages != null &&
                  community.CommunityImages != undefined
                    ? JSON.parse(community.CommunityImages)
                    : [];

                return (
                  <tr
                    className={`${
                      anyCommunityBooked && !isBooked ? " notsuiteBooked" : ""
                    }`}
                    key={index}
                  >
                    <td>
                      <div className="details">
                        {communityImages.length > 0 ? (
                          <div className="image">
                            <img
                              src={communityImages[0].image_name}
                              alt={`${communityImages[0].image_name} banner`}
                            />
                            {communityImages.length > 1 && (
                              <button
                                className="btn photos"
                                onClick={() => handleOpenCarousel(community)}
                                type="button"
                              >
                                + {communityImages.length - 1} Photos
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="image">
                            <img
                              src={community.banner_image}
                              alt={`${community.community_name} banner`}
                            />
                          </div>
                        )}

                        <div
                          className={
                            community.LinkMaster.IsGuestBooked === true
                              ? "suiteBooked"
                              : ""
                          }
                        >
                          <h1>{community.community_name}</h1>
                          <p className="mb-2">
                            {community.address +
                              ", " +
                              community.city_name +
                              ", " +
                              community.state_name +
                              ", " +
                              community.ZipCode}
                          </p>
                          <ul className="CommunityMoreInfo">
                            {community.LinkMaster.SuiteSizeCode != null ? (
                              <li>
                                {" "}
                                <img src="/assets/newUI-images/quotes/size.svg" />{" "}
                                <b>{community.LinkMaster.SuiteSizeCode}</b>
                              </li>
                            ) : null}
                            {community.LinkMaster.Floor != null ? (
                              <li>
                                {" "}
                                <img src="/assets/newUI-images/quotes/appartments.svg" />{" "}
                                <b>Floor {community.LinkMaster.Floor} </b>
                              </li>
                            ) : null}

                            {community.LinkMaster.SquareFootage != null ? (
                              <li>
                                {" "}
                                <img src="/assets/newUI-images/quotes/house-plan.svg" />{" "}
                                <b>
                                  {community.LinkMaster.SquareFootage} ft
                                  <sup>2</sup>
                                </b>
                              </li>
                            ) : null}
                            {(community.LinkMaster.Parking ||
                              community.LinkMaster.Parking2 ||
                              community.LinkMaster.NewOptionParking) &&
                              (() => {
                                let parkingCount = [
                                  community.LinkMaster.Parking,
                                  community.LinkMaster.Parking2,
                                  //community.LinkMaster.NewOptionParking,
                                ].filter(
                                  (p) => p !== null && p !== "" && p !== "none"
                                ).length;
                                parkingCount =
                                  parkingCount +
                                  parseInt(
                                    +community.LinkMaster.NewOptionParking
                                  );
                                return (
                                  parkingCount > 0 && (
                                    <li>
                                      <img
                                        className="parking"
                                        src="/assets/newUI-images/quotes/parkingSpace.svg"
                                      />
                                      <b>
                                        {parkingCount}{" "}
                                        {parkingCount === 1
                                          ? "Space"
                                          : "Spaces"}
                                      </b>{" "}
                                    </li>
                                  )
                                );
                              })()}
                          </ul>

                          {(extraDetails || bedCounts) && (
                            <ul className="CommunityMoreInfo more">
                              {community.LinkMaster.Frequency !== null &&
                                community.LinkMaster.Frequency !== "" && (
                                  <li>
                                    <b>{community.LinkMaster.Frequency} </b>
                                    Housekeeping
                                  </li>
                                )}

                              {community.LinkMaster.NTV && (
                                <li>
                                  <b>{community.LinkMaster.NTV}</b>{" "}
                                  {community.LinkMaster.NTV === 1
                                    ? "Day"
                                    : "Days"}{" "}
                                  NTV{" "}
                                  <Tooltip
                                    title={`Please let us know at least ${
                                      community.LinkMaster.NTV
                                    } ${
                                      community.LinkMaster.NTV === 1
                                        ? "day"
                                        : "days"
                                    } before your scheduled move-out date if you plan to move out or would like to extend your stay.`}
                                  >
                                    <i className="bi bi-info-circle-fill cursor-pointer"></i>
                                  </Tooltip>
                                </li>
                              )}

                              {/* {Object.keys(bedCounts).length > 0 && (
                                <li>
                                  {Object.entries(bedCounts).map(
                                    ([bedType, count], idx, arr) => (
                                      <span key={bedType}>
                                        <b>{count}</b> {bedType}
                                        {idx < arr.length - 1 && ", "}
                                      </span>
                                    )
                                  )}
                                </li>
                              )} */}
                            </ul>
                          )}
                          <button
                            type="button"
                            className="btnAmtModal"
                            data-toggle="modal"
                            data-target="#amenitiesmodal"
                            onClick={() => handleAmenitesPopUp(community)}
                          >
                            Amenities <i class="bi bi-arrow-up-right"></i>
                          </button>

                          <button
                            type="button"
                            className="btnAmtModal"
                            data-toggle="modal"
                            data-target="#greatschoolmodal"
                            onClick={() => handleSchoolsPopUp(community)}
                          >
                            Schools<i class="bi bi-arrow-up-right"></i>
                          </button>
                          <button
                            type="button"
                            className="btnAmtModal pt-0 pb-3"
                            data-toggle="modal"
                            data-target="#NeigbborHoodmodal"
                            onClick={() => handleNeigbborHoodPopUp(community)}
                          >
                            Neighborhood<i class="bi bi-arrow-up-right"></i>
                          </button>
                          {community.LinkMaster.Notes && (
                            <div className="newpara-ptag">
                              <div className="alert alert-info">
                                <i className="fa fa-info-circle"></i>{" "}
                                {community.LinkMaster.Notes}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      {community.LinkMaster.MoveInReady != null
                        ? moment(community.LinkMaster.MoveInReady).format(
                            "MMMM DD, YYYY"
                          )
                        : moment(community.LinkMaster.MoveInDate).format(
                            "MMMM DD, YYYY"
                          )}
                    </td>
                    {shouldShowOfferRate && (
                      <td>
                        {community.LinkMaster.DontShowPrice == null ||
                        (community.LinkMaster.DontShowPrice == false &&
                          community.LinkMaster.OfferedRate != 0) ? (
                          <b>
                            <span className="fare">
                              {" "}
                              ${community.LinkMaster.OfferedRate}/day{" "}
                            </span>
                          </b>
                        ) : null}
                      </td>
                    )}

                    <td>
                      <div
                        className={
                          community.LinkMaster.IsGuestBooked === true
                            ? "tableBtns  suiteBooked"
                            : "tableBtns"
                        }
                      >
                        {community.LinkMaster.IsGuestBooked ? (
                          <button className="btn btn-border-black">
                            <i class="bi bi-check-circle-fill"></i> Booked
                          </button>
                        ) : booked.length === 0 ? (
                          <button
                            className="btn btn-border-black"
                            onClick={() => props.bookNow(community)}
                          >
                            Book Now
                          </button>
                        ) : null}
                        {/* {community.LinkMaster.IsGuestBooked === true && ( */}

                        {/* )} */}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="row d-block">
          {communitysList.map((community, index) => {
            const anyCommunityBooked = communitysList.some(
              (c) => c.LinkMaster.IsGuestBooked
            );
            const isBooked = community.LinkMaster.IsGuestBooked;
            const extraDetails = [
              community.LinkMaster.NTV,
              community.LinkMaster.Frequency,
            ].some((val) => val !== null && val !== "");
            const linkMaster = community.LinkMaster;

            // Count bed types dynamically from BedRoom1 to BedRoom10
            const bedCounts = Object.keys(linkMaster)
              .filter((key) => key.startsWith("BedRoom"))
              .reduce((acc, key) => {
                const bedType = linkMaster[key]?.trim();
                if (bedType) {
                  acc[bedType] = (acc[bedType] || 0) + 1;
                }
                return acc;
              }, {});
            const bedCountString = Object.entries(bedCounts)
              .map(([bedType, count]) => `${count} ${bedType}`)
              .join(", ");
            let communityImages =
              community.CommunityImages != null &&
              community.CommunityImages != undefined
                ? JSON.parse(community.CommunityImages)
                : [];

            return (
              <div
                className={`jessalyne_proitem col-md-6 lastViewExisting${
                  anyCommunityBooked && !isBooked ? " notsuiteBooked" : ""
                }`}
                key={index}
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <h1>{community.community_name}</h1>

                    <p className="mb-2">
                      {[
                        community.address,
                        community.city_name,
                        community.state_name,
                        community.ZipCode,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </p>
                  </div>
                  <div
                    className={` ${
                      community.LinkMaster.IsGuestBooked ? "suiteBooked" : ""
                    }`}
                  >
                    {community.LinkMaster.IsGuestBooked ? (
                      <button className="btn btn-border-black">
                        {" "}
                        <i className="bi bi-check-circle-fill"></i>
                        Booked
                      </button>
                    ) : booked.length === 0 ? (
                      <button
                        className="btn btn-border-black"
                        onClick={() => props.bookNow(community)}
                      >
                        Book Now
                      </button>
                    ) : (
                      <div className="suiteBooked"></div>
                    )}
                  </div>
                </div>
                <ul className="CommunityMoreInfo">
                  {community.LinkMaster.SuiteSizeCode != null ? (
                    <li>
                      {" "}
                      <img src="/assets/newUI-images/quotes/size.svg" />
                      <b>{community.LinkMaster.SuiteSizeCode}</b>
                    </li>
                  ) : null}
                  {community.LinkMaster.Floor != null ? (
                    <li>
                      {" "}
                      <img src="/assets/newUI-images/quotes/appartments.svg" />{" "}
                      <b>Floor {community.LinkMaster.Floor} </b>
                    </li>
                  ) : null}

                  {community.LinkMaster.SquareFootage != null ? (
                    <li>
                      {" "}
                      <img src="/assets/newUI-images/quotes/house-plan.svg" />{" "}
                      <b>
                        {community.LinkMaster.SquareFootage} ft<sup>2</sup>
                      </b>
                    </li>
                  ) : null}
                  {(community.LinkMaster.Parking ||
                    community.LinkMaster.Parking2 ||
                    community.LinkMaster.NewOptionParking) &&
                    (() => {
                      let parkingCount = [
                        community.LinkMaster.Parking,
                        community.LinkMaster.Parking2,
                        //community.LinkMaster.NewOptionParking,
                      ].filter(
                        (p) => p !== null && p !== "" && p !== "none"
                      ).length;
                      parkingCount =
                        parkingCount +
                        parseInt(+community.LinkMaster.NewOptionParking);
                      return (
                        parkingCount > 0 && (
                          <li>
                            <img
                              className="parking"
                              src="/assets/newUI-images/quotes/parkingSpace.svg"
                            />
                            <b>
                              {parkingCount}{" "}
                              {parkingCount === 1 ? "Space" : "Spaces"}
                            </b>{" "}
                          </li>
                        )
                      );
                    })()}
                </ul>

                {(extraDetails || bedCounts) && (
                  <ul className="CommunityMoreInfo more">
                    {community.LinkMaster.Frequency !== null &&
                      community.LinkMaster.Frequency !== "" && (
                        <li>
                          {" "}
                          <b>{community.LinkMaster.Frequency}</b> Housekeeping
                        </li>
                      )}

                    {community.LinkMaster.NTV && (
                      <li>
                        <b>{community.LinkMaster.NTV}</b>{" "}
                        {community.LinkMaster.NTV === 1 ? "Day" : "Days"} NTV{" "}
                        <Tooltip
                          title={`Please let us know at least ${
                            community.LinkMaster.NTV
                          } ${
                            community.LinkMaster.NTV === 1 ? "day" : "days"
                          } before your scheduled move-out date if you plan to move out or would like to extend your stay.`}
                        >
                          <i className="bi bi-info-circle-fill cursor-pointer"></i>
                        </Tooltip>
                      </li>
                    )}

                    {/* {Object.keys(bedCounts).length > 0 && (
                      <li>
                        {Object.entries(bedCounts).map(
                          ([bedType, count], idx, arr) => (
                            <span key={bedType}>
                              <b>{count}</b> {bedType}
                              {idx < arr.length - 1 && ", "}
                            </span>
                          )
                        )}
                      </li>
                    )} */}
                  </ul>
                )}
                {/* <button
                  type="button"
                  className="btnAmtModal pt-2 pb-3"
                  data-toggle="modal"
                  data-target="#amenitiesmodal"
                  onClick={() => handleAmenitesPopUp(community)}
                >
                  Amenities <i class="bi bi-arrow-up-right"></i>
                </button> */}

                <button
                  type="button"
                  className="btnAmtModal pt-0 pb-3"
                  data-toggle="modal"
                  data-target="#greatschoolmodal"
                  onClick={() => handleSchoolsPopUp(community)}
                >
                  Schools<i class="bi bi-arrow-up-right"></i>
                </button>
                <button
                  type="button"
                  className="btnAmtModal pt-0 pb-3"
                  data-toggle="modal"
                  data-target="#NeigbborHoodmodal"
                  onClick={() => handleNeigbborHoodPopUp(community)}
                >
                  Neighborhood<i class="bi bi-arrow-up-right"></i>
                </button>
                <div className="cImages">
                  {communityImages.length > 0 ? (
                    <div className="img_div">
                      <img
                        src={communityImages[0].image_name}
                        // src="https://s3-us-west-1.amazonaws.com/suite-ch/19996/19996_c_4.jpg"
                        alt={`${communityImages[0].image_name} banner`}
                      />
                      {communityImages.length > 1 && (
                        <button
                          className="btn photos"
                          onClick={() => handleOpenCarousel(community)}
                          type="button"
                        >
                          + {communityImages.length - 1} Photos
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="img_div">
                      <img
                        src={community.banner_image}
                        alt={`${community.community_name} banner`}
                      />
                    </div>
                  )}
                </div>
                <p>
                  Available from:{" "}
                  <span className="text-dark  fw-800">
                    {community.LinkMaster.MoveInReady
                      ? moment(community.LinkMaster.MoveInReady).format(
                          "MMMM DD, YYYY"
                        )
                      : moment(community.LinkMaster.MoveInDate).format(
                          "MMMM DD, YYYY"
                        )}
                  </span>
                  {(community.LinkMaster.DontShowPrice == null ||
                    (community.LinkMaster.DontShowPrice === false &&
                      community.LinkMaster.OfferedRate !== 0)) && (
                    <b>
                      {" "}
                      Offered Rate:{" "}
                      <span className="text-dark  fw-800">
                        {" "}
                        ${community.LinkMaster.OfferedRate}/day{" "}
                      </span>
                    </b>
                  )}
                </p>

                {notespresent.length > 0 && (
                  <div className="newpara-ptag">
                    {community.LinkMaster.Notes && (
                      <div className="alert alert-info">
                        <i className="fa fa-info-circle"></i>{" "}
                        {community.LinkMaster.Notes}
                      </div>
                    )}
                  </div>
                )}

                {AmenitiesRes(community, index, (showMoreInfoTab = true))}
              </div>
            );
          })}
        </div>
      )}

      <div className="sa-community-details">
        <div
          className="modal fade-scale  SAweb_modalPoup"
          id="amenitiesmodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-lg-SAweb  modal-dialog-scrollable modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div class="modal-body border-0 mb-5">
                <AmenitesListPopUp community={selectedCommunity} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sa-community-details">
        <div
          className="modal fade-scale  SAweb_modalPoup"
          id="greatschoolmodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            className="modal-dialog modal-lg-SAweb  modal-dialog-scrollable modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className=" btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleSchoolsPopUp(null)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div class="modal-body border-0 mb-5">
                <div className="SAweb_amenities ">
                  <GreatSchoolsPopUp community={selected} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sa-community-details">
        <div
          className="modal fade-scale  SAweb_modalPoup"
          id="NeigbborHoodmodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            className="modal-dialog modal-lg-SAweb  modal-dialog-scrollable modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className=" btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleAmenitesPopUp(null)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div class="modal-body border-0 mb-5">
                <div className="SAweb_amenities ">
                  <NeighborhoodPage community={selected} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FullPopup fullpopdata={communityData} />
    </>
  );
};
export default Communitys;
